import styled from "styled-components";
import { useState, useEffect } from "react";
import PrimaryButton from "../../../../components/FormControls/PrimaryButton";
import SecondaryButton from "../../../../components/FormControls/SecondaryButton";
import request from "../../../../api/request";
import Grid2Groups from "../../../../components/Grid2Groups";
import FormStringInput from "../../../../components/FormControls/FormStringInput";
import FormSelectWithLabel from "../../../../components/FormControls/FormSelectWithLabel";
import FormNumberInputNoSpinner from "../../../../components/FormControls/FormNumberInputNoSpinner";
import FormCheckBoxWithRightLabel from "../../../../components/FormControls/FormCheckBoxWithRightLabel";
import { NotificationManager } from 'react-notifications';

const StyledBalanceSheetOpeningBalances = styled.div`
`;

const WhiteBoard = styled.div`
    background-color: white;
    width: 1000px;
    box-sizing: border-box;
    min-height: 526px;
    padding: 30px;
    margin-bottom: 30px;
    color: ${(props) => props.theme.color.gray};
`;

function BalanceSheetOpeningBalances(props) {

    let currentYear = new Date().getFullYear();

    const [loadedPage, setLoadedPage] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [balances, setBalances] = useState([]);
    const [branches, setBranches] = useState([]);
    const [selectedBalance, setSelectedBalance] = useState(null);
    const [selectedBalanceId, setSelectedBalanceId] = useState(null);
    const [isAddBalanceMode, setIsAddBalanceMode] = useState(false);
    const [gridColumns, setGridColumns] = useState([
        {id: 'Division Code', type: 'String', width: 100, textAlign: 'left'},
        {id: 'Account type', type: 'String', width: 110, textAlign: 'center'},
        {id: 'Festival', type: 'String', width: 75, textAlign: 'center'},
        {id: 'Section', type: 'String', width: 75, textAlign: 'center'},
        {id: 'Code', type: 'String', width: 70, textAlign: 'center'},
        {id: 'Opening balance', type: 'String', width: 130, textAlign: 'right'},
    ]);
    const [gridData, setGridData] = useState({groups: [{name: 'Type: Branches', subGroups: []}, {name: 'Type: Sub-branches', subGroups: []}], items: [[[]], [[]]]});


    const [recordType, setRecordType] = useState(1);
    const [accountingYear, setAccountingYear] = useState(props.baseYear);
    const [branchCommitteeCode, setBranchCommitteeCode] = useState('');
    const [recordName, setRecordName] = useState('');
    const [fundTypeCode, setFundTypeCode] = useState('B');
    const [restrictedFundCode, setRestrictedFundCode] = useState('');
    const [sectionNumber, setSectionNumber] = useState(0);
    const [analysisCode, setAnalysisCode] = useState('');
    const [openingBalance, setOpeningBalance] = useState('0.00');
    const [canExport, setCanExport] = useState(true);
    
    const [branchNames, setBranchNames] = useState([]);
    const [needsValidation, setNeedsValidation] = useState(false);
    const [isAddingDuplicatedBalance, setIsAddingDuplicatedBalance] = useState(false);
    
    let branchTypes = ['Branch', 'Sub-Branch'];
    const branchTypeStringToInt = (branchTypeStr) => {
        if (branchTypeStr === 'Branch') {
            return 1;
        } else {
            return 2;
        }
    }

    const branchNameFromBranchCommitteeCode = (recordType, branchCommitteeCode, divisionCode) => {
        let branchName = '';
        for (let i = 0; i < branches.length; i ++) {
            if (branches[i].RecordType === recordType && branches[i].BranchCommitteeCode === branchCommitteeCode && branches[i].DivisionCode === divisionCode) {
                branchName = branches[i].RecordName;
                break;
            }
        }
        return branchName;
    }

    const branchCommitteeCodeFromBranchName = (recordType, branchName) => {
        let branchCommitteeCode = '';
        for (let i = 0; i < branches.length; i ++) {
            if (branches[i].RecordType === recordType && branches[i].RecordName === branchName) {
                branchCommitteeCode = branches[i].BranchCommitteeCode;
                break;
            }
        }
        return branchCommitteeCode;
    }

    const divisionCodeFromBranchName = (recordType, branchCommitteeCode, branchName) => {
        let divisionCode = '';
        for (let i = 0; i < branches.length; i ++) {
            if (branches[i].RecordType === recordType && branches[i].BranchCommitteeCode === branchCommitteeCode && branches[i].RecordName === branchName) {
                divisionCode = branches[i].DivisionCode;
                break;
            }
        }
        return divisionCode;
    }

    const onChangeRecordType = (e) => {
        let bType = branchTypeStringToInt(e.target.value);
        setRecordType(bType);
    }

    const onChangeBranchName = (e) => {
        setRecordName(e.target.value);
        setBranchCommitteeCode(branchCommitteeCodeFromBranchName(recordType, e.target.value));
    }

    const onSelectGridItem = (item) => {
        setSelectedBalanceId(item.Id);
        setSelectedBalance(item);
    }
    
    const fetchBalances = async (recordTypeToSelect, branchCommitteeCodeToSelect, fundTypeCodeToSelect, analysisCodeToSelect) => {
        try {
            let balanceList = [];

            const resp = (await request('database', 'fetchBalanceSheetOpeningBalances'));
            if (resp.ok) {
                resp.data.map((balance, index) => {
                    balanceList.push(balance);
                });
                setBalances(balanceList);
                rebuildGridData(balanceList, recordTypeToSelect, branchCommitteeCodeToSelect, fundTypeCodeToSelect, analysisCodeToSelect);
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
                return false;
            }
        } catch (e) {
            console.log('Failed to fetch balance sheet opening balances: ', e);
            return false;
        }
        return true;
    }
    
    const fetchBranches = async () => {
        try {
            let branchList = [];

            const resp = (await request('database', 'fetchBranches'));
            if (resp.ok) {
                resp.data.map((branch, index) => {
                    branchList.push(branch);
                });
                setBranches(branchList);
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
                return false;
            }
        } catch (e) {
            console.log('Failed to fetch branches: ', e);
            return false;
        }
        return true;
    }

    const onDeleteBalance = async () => {
        if (selectedBalance) {
            setIsDeleting(true);
            let deleteData = selectedBalance;
            
            const resp = (await request('database', 'deleteBalanceSheetOpeningBalance', [deleteData]));
            if (resp.ok) {
                setSelectedBalance(null);
                setSelectedBalanceId(null);
                fetchBalances();
                NotificationManager.success('Successfully deleted balance');
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
            }
            setIsDeleting(false);
        }
    }

    const onSaveChanges = async () => {
        if (isAddBalanceMode) { // adding new item
            if (analysisCode.length !== 1 || sectionNumber === 0 || isNaN(parseFloat(openingBalance))) {
                setNeedsValidation(true);
            } else {
                // check duplicated code
                if (balances.length > 0 && (balances.find((itm) => itm.RecordType === recordType && itm.AccountingYear === accountingYear && itm.FundTypeCode.replace(/\s/g, '') === fundTypeCode && itm.BranchCommitteeCode === branchCommitteeCode && itm.SectionNumber === sectionNumber && itm.AnalysisCode === analysisCode))) {
                    setIsAddingDuplicatedBalance(true);
                } else {
                    setIsSaving(true);
                    let saveData = {};
                    saveData.RecordType = recordType;
                    saveData.AccountingYear = accountingYear;
                    saveData.BranchCommitteeCode = branchCommitteeCode;
                    saveData.DivisionCode = divisionCodeFromBranchName(recordType, branchCommitteeCode, recordName);
                    saveData.FundTypeCode = fundTypeCode;
                    saveData.RestrictedFundCode = restrictedFundCode.replace(/\s/g, '').length > 0 ? restrictedFundCode.replace(/\s/g, '') : null;
                    saveData.SectionNumber = sectionNumber;
                    saveData.AnalysisCode = analysisCode;
                    saveData.OpeningBalance = parseFloat(openingBalance);
                    saveData.CanExport = canExport;

                    const resp = (await request('database', 'createBalanceSheetOpeningBalance', [saveData]));
                    if (resp.ok) {
                        fetchBalances(recordType, branchCommitteeCode, fundTypeCode, analysisCode);
                        NotificationManager.success('Successfully added balance');
                    } else
                    {
                        console.log(resp.data);
                        NotificationManager.error(resp.data);
                    }
                    setIsSaving(false);
                    setIsAddBalanceMode(false);
                }
            }
        } else {
            if (analysisCode.length !== 1 || sectionNumber === 0 || isNaN(parseFloat(openingBalance))) {
                setNeedsValidation(true);
            } else {
                // check duplicated code
                if (balances.length > 0 && (balances.find((itm) => (itm.RecordType !== selectedBalance.RecordType || itm.AccountingYear !== selectedBalance.AccountingYear || itm.FundTypeCode !== selectedBalance.FundTypeCode || itm.BranchCommitteeCode !== selectedBalance.BranchCommitteeCode || itm.SectionNumber !== selectedBalance.SectionNumber || itm.AnalysisCode !== selectedBalance.AnalysisCode) && itm.RecordType === recordType && itm.AccountingYear === accountingYear && itm.FundTypeCode.replace(/\s/g, '') === fundTypeCode && itm.BranchCommitteeCode === branchCommitteeCode && itm.SectionNumber === sectionNumber && itm.AnalysisCode === analysisCode))) {
                    setIsAddingDuplicatedBalance(true);
                } else {
                    setIsSaving(true);
                    let saveData = {};
                    saveData.RecordType = recordType;
                    saveData.AccountingYear = accountingYear;
                    saveData.BranchCommitteeCode = branchCommitteeCode;
                    saveData.DivisionCode = divisionCodeFromBranchName(recordType, branchCommitteeCode, recordName);
                    saveData.FundTypeCode = fundTypeCode;
                    saveData.RestrictedFundCode = restrictedFundCode.replace(/\s/g, '').length > 0 ? restrictedFundCode.replace(/\s/g, '') : null;
                    saveData.SectionNumber = sectionNumber;
                    saveData.AnalysisCode = analysisCode;
                    saveData.OpeningBalance = parseFloat(openingBalance);
                    saveData.CanExport = canExport;

                    saveData.OldRecordType = selectedBalance.RecordType;
                    saveData.OldAccountingYear = selectedBalance.AccountingYear;
                    saveData.OldBranchCommitteeCode = selectedBalance.BranchCommitteeCode;
                    saveData.OldFundTypeCode = selectedBalance.FundTypeCode;
                    saveData.OldSectionNumber = selectedBalance.SectionNumber;
                    saveData.OldAnalysisCode = selectedBalance.AnalysisCode;

                    const resp = (await request('database', 'updateBalanceSheetOpeningBalance', [saveData]));
                    if (resp.ok) {
                        fetchBalances(recordType, branchCommitteeCode, fundTypeCode, analysisCode);
                        NotificationManager.success('Successfully updated balance');
                    } else
                    {
                        console.log(resp.data);
                        NotificationManager.error(resp.data);
                    }
                    setIsSaving(false);
                    setIsAddBalanceMode(false);
                }
            }
        }
    }

    const floatToString = (val) => {
        return val.toFixed(2);
    }

    const rebuildGridData = (balances, recordTypeToSelect, branchCommitteeCodeToSelect, fundTypeCodeToSelect, analysisCodeToSelect) => {
        if (balances && balances.length > 0) {
            let branchBalances = [];
            let subBranchBalances = [];
            let branchNameStringsForBranch = [];
            let branchNameStringsForSubBranch = [];
            let prevBranchCommitteeCode = null;
            let subArrBranches = [];
            let subArrSubBranches = [];

            let selectGridItem;
            let selectGridItemId;

            balances.sort((a,b) => {return a.BranchCommitteeCode < b.BranchCommitteeCode ? -1 : 1}).map((balance, index) => {
                if (balance.AccountingYear === props.baseYear) {
                    let gridItem = {Id: index,
                                    'Division Code': balance.DivisionCode,
                                    'Account type': balance.FundTypeCode.replace(/\s/g, ''),
                                    Festival: balance.RestrictedFundCode ? balance.RestrictedFundCode : '',
                                    Section: balance.SectionNumber.toString(),
                                    Code: balance.AnalysisCode,
                                    'Opening balance': floatToString(balance.OpeningBalance),
                                    ...balance};
                    if (balance.BranchCommitteeCode !== prevBranchCommitteeCode) {
                        if (prevBranchCommitteeCode !== null) {
                            if (subArrBranches.length > 0) {
                                branchBalances.push(structuredClone(subArrBranches));
                                subArrBranches.splice(0, subArrBranches.length);
                            }
                            if (subArrSubBranches.length > 0) {
                                subBranchBalances.push(structuredClone(subArrSubBranches));
                                subArrSubBranches.splice(0, subArrSubBranches.length);
                            }
                        }
                        if (balance.RecordType === 1) {
                            branchNameStringsForBranch.push(balance.BranchCommitteeCode + " - " + branchNameFromBranchCommitteeCode(balance.RecordType, balance.BranchCommitteeCode, balance.DivisionCode));
                        } else {
                            branchNameStringsForSubBranch.push(balance.BranchCommitteeCode + " - " + branchNameFromBranchCommitteeCode(balance.RecordType, balance.BranchCommitteeCode, balance.DivisionCode));
                        }

                        prevBranchCommitteeCode = balance.BranchCommitteeCode;
                    }
                    if (balance.RecordType === 1) {
                        subArrBranches.push(gridItem);
                    } else {
                        subArrSubBranches.push(gridItem);
                    }
                    if (recordTypeToSelect && branchCommitteeCodeToSelect && fundTypeCodeToSelect && analysisCodeToSelect && balance.RecordType === recordTypeToSelect && balance.BranchCommitteeCode === branchCommitteeCodeToSelect && balance.FundTypeCode.replace(/\s/g, '') === fundTypeCodeToSelect.replace(/\s/g, '') && balance.AnalysisCode === analysisCodeToSelect) {
                        selectGridItem = gridItem;
                        selectGridItemId = index;
                    }
                }
            });
            if (subArrBranches.length > 0) {
                branchBalances.push(structuredClone(subArrBranches));
            }
            if (subArrSubBranches.length > 0) {
                subBranchBalances.push(structuredClone(subArrSubBranches));
            }
            setGridData({groups: [{name: 'Type: Branches', subGroups: branchNameStringsForBranch}, {name: 'Type: Sub-branches', subGroups: branchNameStringsForSubBranch}], items: [branchBalances, subBranchBalances]});
            setSelectedBalanceId(selectGridItemId);
            setSelectedBalance(selectGridItem);
        }
    }

    useEffect(() => {
        if (!loadedPage) {
            fetchBalances();
            fetchBranches();
            setLoadedPage(true);
        }
        rebuildGridData(balances);

        setRecordType(1);
        setAccountingYear(props.baseYear);
        if (branches.length > 0) {
            let b = branches.find((itm) => itm.RecordType === 1);
            setBranchCommitteeCode(b.BranchCommitteeCode);
            setRecordName(b.RecordName);
        } else {
            setBranchCommitteeCode('');
            setRecordName('None');
        }
        setFundTypeCode('B');
        setRestrictedFundCode('');
        setSectionNumber(0);
        setAnalysisCode('');
        setOpeningBalance('0.00');
        setCanExport(true);
        setSelectedBalance(null);
        setSelectedBalanceId(null);
        setNeedsValidation(false);
    }, [props.baseYear, branches]);

    useEffect(() => {
        if (isAddBalanceMode) {
            setNeedsValidation(false);
            setRecordType(1);
            setAccountingYear(props.baseYear);
            if (branches.length > 0) {
                let b = branches.find((itm) => itm.RecordType === 1);
                setBranchCommitteeCode(b.BranchCommitteeCode);
                setRecordName(b.RecordName);
            } else {
                setBranchCommitteeCode('');
                setRecordName('None');
            }
            setFundTypeCode('B');
            setRestrictedFundCode('');
            setSectionNumber(0);
            setAnalysisCode('');
            setOpeningBalance('0.00');
            setCanExport(true);
        } else if (selectedBalance) {
            setNeedsValidation(false);
            setRecordType(selectedBalance.RecordType);
            setAccountingYear(selectedBalance.AccountingYear);
            if (branches.length > 0) {
                let b = branches.find((itm) => itm.RecordType === selectedBalance.RecordType && itm.BranchCommitteeCode === selectedBalance.BranchCommitteeCode && itm.DivisionCode === selectedBalance.DivisionCode);
                if (b) {
                    setBranchCommitteeCode(b.BranchCommitteeCode);
                    setRecordName(b.RecordName);
                } else {
                    setBranchCommitteeCode('');
                    setRecordName('None');
                }
            } else {
                setBranchCommitteeCode('');
                setRecordName('None');
            }
            setFundTypeCode(selectedBalance.FundTypeCode);
            setRestrictedFundCode(selectedBalance.RestrictedFundCode ? selectedBalance.RestrictedFundCode : '');
            setSectionNumber(selectedBalance.SectionNumber);
            setAnalysisCode(selectedBalance.AnalysisCode);
            setOpeningBalance(floatToString(selectedBalance.OpeningBalance));
            setCanExport(selectedBalance.CanExport);
        }
    }, [isAddBalanceMode]);

    useEffect(() => {
        setIsAddingDuplicatedBalance(false);

        let branchNameList = [];
        let isRefreshedBranchName = false;
        branches.map((b, idx) => {
            if (b.RecordType === recordType) {
                branchNameList.push(b.RecordName);
                if (!isRefreshedBranchName) {
                    if (isAddBalanceMode || (selectedBalance && selectedBalance.RecordType !== recordType)) {
                        setBranchCommitteeCode(b.BranchCommitteeCode);
                        setRecordName(b.RecordName);
                    } else if (selectedBalance && selectedBalance.RecordType === recordType) {
                        setBranchCommitteeCode(selectedBalance.BranchCommitteeCode);
                        setRecordName(branchNameFromBranchCommitteeCode(selectedBalance.RecordType, selectedBalance.BranchCommitteeCode, selectedBalance.DivisionCode));
                    }
                    isRefreshedBranchName = true;
                }
            }
        });
        setBranchNames(branchNameList)
    }, [branches, recordType]);

    useEffect(() => {
        setIsAddingDuplicatedBalance(false);
    }, [accountingYear, fundTypeCode, analysisCode, sectionNumber]);

    useEffect(() => {
        setIsAddingDuplicatedBalance(false);
        setNeedsValidation(false);
    }, [props.baseYear, selectedBalance, isAddBalanceMode]);

    useEffect(() => {
        if (selectedBalance) {
            setRecordType(selectedBalance.RecordType);
            setAccountingYear(selectedBalance.AccountingYear);
            if (branches.length > 0) {
                let b = branches.find((itm) => itm.RecordType === selectedBalance.RecordType && itm.BranchCommitteeCode === selectedBalance.BranchCommitteeCode && itm.DivisionCode === selectedBalance.DivisionCode);
                if (b) {
                    setBranchCommitteeCode(b.BranchCommitteeCode);
                    setRecordName(b.RecordName);
                } else {
                    setBranchCommitteeCode('');
                    setRecordName('None');
                }
            } else {
                setBranchCommitteeCode('');
                setRecordName('None');
            }
            setFundTypeCode(selectedBalance.FundTypeCode.replace(/\s/g, ''));
            setRestrictedFundCode(selectedBalance.RestrictedFundCode ? selectedBalance.RestrictedFundCode : '');
            setSectionNumber(selectedBalance.SectionNumber);
            setAnalysisCode(selectedBalance.AnalysisCode);
            setOpeningBalance(floatToString(selectedBalance.OpeningBalance));
            setCanExport(selectedBalance.CanExport);
        } else {
            setNeedsValidation(false);
            setRecordType(1);
            setAccountingYear(props.baseYear);
            if (branches.length > 0) {
                let b = branches.find((itm) => itm.RecordType === 1);
                setBranchCommitteeCode(b.BranchCommitteeCode);
                setRecordName(b.RecordName);
            } else {
                setBranchCommitteeCode('');
                setRecordName('None');
            }
            setFundTypeCode('B');
            setRestrictedFundCode('');
            setSectionNumber(0);
            setAnalysisCode('');
            setOpeningBalance('0.00');
            setCanExport(true);
        }
    }, [selectedBalance]);

    return (
        <StyledBalanceSheetOpeningBalances>
            <WhiteBoard>
                <div style={{display:'flex'}}>
                    <div>
                        <Grid2Groups id='balancesheet_openingbalance_grid' gridColumns={gridColumns} gridData={gridData} disabled={isAddBalanceMode} itemIdToSelect={selectedBalanceId} onSelectGridItem={onSelectGridItem} gridStyle={{width:560, height:400}}></Grid2Groups>
                        <div style={{marginTop:20}}>
                            {selectedBalance && !isAddBalanceMode && <SecondaryButton caption='Delete' isLoading={isDeleting} onClick={() => onDeleteBalance()} style={{width:75, height:25}}></SecondaryButton>}
                            {isAddBalanceMode && <SecondaryButton caption='Cancel' onClick={() => setIsAddBalanceMode(false)} style={{width:75, height:25, float:'right'}}></SecondaryButton>}
                            {!isAddBalanceMode && <PrimaryButton caption='Create new' onClick={() => setIsAddBalanceMode(true)} style={{width:100, height:25, float:'right'}}></PrimaryButton>}
                        </div>
                    </div>
                    <div style={{marginLeft:30}}>
                        <div style={{display:'flex'}}>
                            <FormNumberInputNoSpinner label='Year' value={accountingYear} disabled={!isAddBalanceMode || (selectedBalance && selectedBalance.IsExported)} onChange={(val) => setAccountingYear(val)} inputStyle={{width:100, height:35}} style={{paddingTop:0}}></FormNumberInputNoSpinner>
                            <FormSelectWithLabel label='Type' items={branchTypes} value={branchTypes[recordType-1]} disabled={(!isAddBalanceMode && !selectedBalance) || (selectedBalance && selectedBalance.IsExported)} onChange={(e) => onChangeRecordType(e)} style={{width:220, height:35, paddingLeft:10}} selectStyle={{paddingTop:0, marginLeft:18}}></FormSelectWithLabel>
                        </div>
                        <div style={{display: 'flex'}}>
                            <FormStringInput label='Branch code' value={branchCommitteeCode} disabled={true} inputStyle={{width:100, height:35}}></FormStringInput>
                            <FormSelectWithLabel label='Branch / Sub-branch' items={!isAddBalanceMode && !selectedBalance ? ['None'] : branchNames} value={recordName} disabled={(!isAddBalanceMode && !selectedBalance) || (selectedBalance && selectedBalance.IsExported)} onChange={(e) => onChangeBranchName(e)} style={{width:220, height:35, paddingLeft:10}} selectStyle={{marginLeft:18}}></FormSelectWithLabel>
                        </div>

                        <FormSelectWithLabel label='Account type' items={!isAddBalanceMode && !selectedBalance ? ['None'] : ['B', 'BF']} value={fundTypeCode} disabled={(!isAddBalanceMode && !selectedBalance) || (selectedBalance && selectedBalance.IsExported)} onChange={(e) => setFundTypeCode(e.target.value)} style={{width:100, height:35, paddingLeft:10}} selectStyle={{marginTop:15}}></FormSelectWithLabel>

                        <div style={{display: 'flex'}}>
                            <FormStringInput label='Festival' value={restrictedFundCode ? restrictedFundCode : ''} disabled={(!isAddBalanceMode && !selectedBalance) || (selectedBalance && selectedBalance.IsExported)} onChange={(val) => setRestrictedFundCode(val)} inputStyle={{width:100, height:35}}></FormStringInput>
                            <FormNumberInputNoSpinner label='Section' value={sectionNumber} disabled={(!isAddBalanceMode && !selectedBalance) || (selectedBalance && selectedBalance.IsExported)} onChange={(val) => setSectionNumber(val)} validated={needsValidation && sectionNumber===0 ? false : undefined} inputStyle={{width:100, height:35}} style={{marginLeft:18}}></FormNumberInputNoSpinner>
                            <FormStringInput label='Code' value={analysisCode} disabled={(!isAddBalanceMode && !selectedBalance) || (selectedBalance && selectedBalance.IsExported)} onChange={(val) => setAnalysisCode(val)} validated={needsValidation && analysisCode.length !== 1 ? false : undefined} inputStyle={{width:100, height:35}} style={{marginLeft:18}}></FormStringInput>
                        </div>

                        <FormStringInput label='Opening balance' value={openingBalance} disabled={(!isAddBalanceMode && !selectedBalance) || (selectedBalance && selectedBalance.IsExported)} validated={needsValidation && isNaN(parseFloat(openingBalance)) ? false : undefined} onChange={(val) => setOpeningBalance(val)} inputStyle={{width:337, height:35}}></FormStringInput>
                        <FormCheckBoxWithRightLabel label='Export to SkyEnterprise' checked={canExport} disabled={(!isAddBalanceMode && !selectedBalance) || (selectedBalance && selectedBalance.IsExported)} onCheck={(val) => setCanExport(val)}></FormCheckBoxWithRightLabel>
                        
                        {isAddingDuplicatedBalance && <div style={{marginTop:30, width:330, fontSize:12, fontWeight:700, color:'#dc3545'}}>* Analysis code is duplicated.</div>}
                    </div>
                </div>
            </WhiteBoard>
            <div>
                <PrimaryButton caption={isAddBalanceMode ? 'Add new' : 'Save changes'} isLoading={isSaving} onClick={() => onSaveChanges()} disabled={isAddBalanceMode || selectedBalance ? false : true} style={{width:150, float:'right'}}></PrimaryButton>
            </div>
        </StyledBalanceSheetOpeningBalances>
    )
}

export default BalanceSheetOpeningBalances;